import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import productStyle from "assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx";
import image1 from "assets/img/07012019001.png";
import image101 from "assets/img/07012019002.png";
// import image102 from "assets/img/14122018-2.png";
// import imageIso from "assets/img/27000family.png";

class ProductSection extends React.Component {
  state = {
    open: false,
    expanded: null,
  };

  handleClick = () => {
    this.setState(state => ({ open: !state.open }));
  };

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  render() {
    // const { expanded } = this.state;
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <div className={classes.container}>
          <GridContainer justify="center" style={{ textAlign: "left", color: "black" }}>
            <GridItem xs={12} sm={12} md={10}>
              <Card>
                <CardBody>
                  <span style={{ marginBottom: 0 }}>07 January 2019, 08.00 PM</span>
                  <h2 style={{ color: "#4BB64B", marginTop: 0 }}><b>SMK PGRI 1 & SMK PGRI 3: Awareness Training ISO 9001:2015</b></h2>
                  <span style={{ fontSize: 18 }}>
                    <br />
                    <center>
                      <img src={image1} alt="Images" style={{ width: 624, height: 461, marginRight: 25 }} />
                    </center> <br /><br />
                    <p style={{ fontSize: 18 }}>
                    SMK PGRI 1 dan SMK PGRI 3 Kota Serang, di Provinsi Banten merupakan sekolah menengah kejuruan swasta pertama yang memiliki sertifikat standar internasional ISO 9001:2015.  Kesadaran akan pentingnya sistem mutu manajemen yang berstandar internasional dalam sebuah organisasi membuat SMK PGRI 1 dan SMK PGRI 3 berani menerima tantangan untuk mengedepankan dan meningkatkan mutu manajemen juga mutu pendidikan sekolah tersebut sehingga SMK PGRI 1 dan SMK PGRI 3 saat ini berhasil menjadi sekolah favorit masyarakat Kota Serang.
                    </p>
                    <p style={{ fontSize: 18 }}>
                    Dengan adanya sertifikasi standar internasional ISO 9001:2015 lulusan siswa dari SMK PGRI 1 dan SMK PGRI 3 menjadi sumber daya manusia yang ahli dan mampu bersaing dalam dunia kerja professional. Terbukti dengan adanya kerjasama dengan beberapa perusahaan yang secara rutin mengadakan walk in interview di sekolah tersebut untuk merekrut lulusan terbaik SMK PGRI 1 dan SMK PGRI 3. 
                    </p><br />
                    <center>
                      <img src={image101} alt="Images" style={{ width: 500, height: 350, marginRight: 25 }} />
                    </center> <br /><br />
                    <p style={{ fontSize: 18 }}>
                    PT. Sandton Sukses Bersama mendapatkan kepercayaan untuk memberikan in house training ISO 9001:2015 pada tanggal 18 Desember 2018 bertempat di sekolah SMK PGRI 3 Kota Serang, Banten. Tujuan diadakan training ini supaya seluruh staff dan pengurus sekolah SMK PGRI 1 dan SMK PGRI 3 semakin meningkatkan pemahaman dan kesadaran agar standar internasional mutu manajemen organisasi tetap berjalan dengan baik. Sehingga masyarakat tetap memilih SMK PGRI 1 dan SMK PGRI 3 Kota Serang sebagai sekolah yang memiliki kualitas pendidikan serta manajemen terbaik, juga menghasilkan lulusan siswa terbaik.
                    </p>
                    <p style={{ fontSize: 18 }}>
                      Terima kasih kepada pimpinan dari SMK PGRI 1 dan SMK PGRI 3 atas sambutan yang hangat dan percaya kepada kami untuk memberikan pelatihan kepada seluruh staff. Sesuai dengan motto perusahaan kami <b>“Inspiring World Quality System”</b>, semoga pelatihan yang sudah berlangsung dapat memberikan inspirasi dan dampak yang baik ke dalam maupun diluar lingkungan sekolah. 
                    </p>
                  </span>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
      </div>
      </div >
    );
  }
}

export default withStyles(productStyle)(ProductSection);



// WEBPACK FOOTER //
// ./src/views/News/Sections/ProductSection.5.jsx